<template>
    <ul class="title-box">
        <li class="btn-part" style="text-align: left">
            <span class="btn-span" @click="goIndex" v-show="obj.hasBack === true"><font-awesome-icon icon="fa-solid fa-angle-left" /></span>

          <el-button circle @click="clickchangeLange1" style="margin-left: 8px;" >
            <font-awesome-icon icon="fa-solid fa-language" />
          </el-button>
        </li>

        <li class="text-part">
            {{obj.name}}
        </li>

        <li class="btn-part" style="text-align: right; position: relative">
            &nbsp;
            <div style="position: absolute; right: 0px;top: 0; width: 200%">
<!--                <a :href="websiteUrl" target="eshopopee" v-if="null !== companyInfoRef.acccompanycode">-->
<!--                    <el-button circle style="margin-right: 10px" >-->
<!--                        <font-awesome-icon icon="fa-solid fa-globe" />-->
<!--                    </el-button>-->
<!--                </a>-->

                <el-badge
                    :value="chatInfoRef.msgCount"
                    :max="99"
                    :hidden="chatInfoRef.msgCount === 0"
                    v-show="showChatBtn !== false && null != userInfoRef.login"
                    style="margin-right: 45px"
                >
<!--             聊天按鈕
                    <el-button circle @click="clickChatFunc" >
                        <font-awesome-icon icon="fa-solid fa-comments" />
                    </el-button>-->
                </el-badge>
            </div>

        </li>
    </ul>

  <languageSelect v-if="langSelectVisible1 == true" @save-complete="langSelectVisible1 = false" />
</template>

<script setup>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faAngleLeft, faComments,faLanguage} from '@fortawesome/free-solid-svg-icons'
    import {getCurrentInstance, ref, computed, toRef} from 'vue'
    import {useChatinfo} from "@/stores/chatinfo";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import LanguageSelect from "@/components/Shopopee3D/ui/languageSelect.vue";
    // import {useCompanyinfo} from "@/stores/companyinfo";

    library.add(faAngleLeft, faComments,faLanguage)

    const emits = defineEmits(['goBack', 'clickChatFunc'])
    const props = defineProps(['obj', 'showChatBtn'])

    let { proxy } = getCurrentInstance();

    const chatInfoRef = toRef(useChatinfo())
    const userInfoRef = toRef(useUserinfo())
    //是否顯示語言選擇框
    const langSelectVisible1 = ref(false)
    //響應機制的companyinfo
    // const companyInfoRef = toRef(useCompanyinfo())

    // const websiteUrl = computed(() => {
    //     return myUtil.generateEShopopeeShopUrl(companyInfoRef.value.acccompanycode)
    // })

    function goIndex() {
        emits("goBack")
    }
    function clickchangeLange1(){
      langSelectVisible1.value=true;
    }

    function clickChatFunc(){
        emits("clickChatFunc")
    }


</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .title-box {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 5px;
        font-size: 18px;
        border-bottom: 1px #e9e9e9 solid;
        width: 100%;
        height: 100%;
        background: #f9f9f9;
    }

    .btn-part {
        width: 15%;
        font-size: 1.5em;
    }

    .text-part {
        width: 70%;
    }

    .btn-span {
        margin-left: 20px;
        margin-right: 20px;
    }

    @media screen and (max-width: 768px) {
      .btn-span {
        margin-left: 10px;
        margin-right: 10px;
      }
      .btn-part {
        width: 22%;
        font-size: 1.5em;
      }
    }


</style>